import { getBackOfficeAPIPath } from '@treasury/core/http';

angular
    .module('backOffice')
    .factory('companyUserChallengeSettingsService', companyUserChallengeSettingsService);

companyUserChallengeSettingsService.$inject = ['$resource'];

function companyUserChallengeSettingsService($resource) {
    const resourceUrl = `${getBackOfficeAPIPath()}companyUserChallengeSettings/`;
    const resourceUrlUisSecurityLevels = `${getBackOfficeAPIPath()}companyUserChallengeSettings/uisSecurityLevel`;
    const resourceUrlAuthenticationSettings = `${getBackOfficeAPIPath()}companyUserChallengeSettings/institutionUisIdentitySettings`;
    const resourceUrlSaveSecurityLevels = `${getBackOfficeAPIPath()}companyUserChallengeSettings/institutionUisIdentitySettings`;

    return {
        getCompanyUserChallengeSettings,
        updateUserChallengeSettings,
        getUisSecurityLevels,
        getAuthenticationSettings,
        saveSecurityLevels,
    };

    function getCompanyUserChallengeSettings() {
        return $resource(resourceUrl).get().$promise;
    }

    function updateUserChallengeSettings(settings) {
        const resource = $resource(resourceUrl, {}, { update: { method: 'PUT' } });
        return resource.update(settings).$promise;
    }

    function getUisSecurityLevels() {
        return $resource(resourceUrlUisSecurityLevels).query().$promise;
    }
    function getAuthenticationSettings() {
        return $resource(resourceUrlAuthenticationSettings).get().$promise;
    }
    function saveSecurityLevels(settings) {
        const resource = $resource(
            resourceUrlSaveSecurityLevels,
            {},
            { update: { method: 'POST' } }
        );
        return resource.update(settings).$promise;
    }
}
